import $ from 'jquery';

const hero = () => {
  const heroFull = $('[data-bg-mobile]');
  if (heroFull && heroFull.length) {
    const $win = $(window);
    const bgMobile = heroFull.data('bg-mobile');
    const bg = heroFull.data('bg');
    const onResize = () => {
      if (bgMobile && $win.width() < 768) {
        heroFull.css('background-image', `url(${bgMobile})`);
      }
      if (bg && $win.width() >= 768) {
        heroFull.css('background-image', `url(${bg})`);
      }
    };
    onResize();
    $win.resize(() => {
      onResize();
    });
  }
};
export default hero;



// WEBPACK FOOTER //
// ./src/scripts/modules/hero.js